import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

export interface UpsertReferrerParams {
  user_uuid?: string;
  role?: string;
  partner_id?: string;
  referrer_team_id?: string;
  requested_callback?: boolean;
}

/**
 * Builds the callApi config for the referrers endpoint.
 */
export function buildReferrersConfig(
  params: UpsertReferrerParams,
  signal?: AbortSignal,
): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.REFERRERS,
    body: params as Record<string, unknown>,
    ...(signal ? { signal } : {}),
  };
}
